import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { TransferAmountWrapper } from "../styles";
import TransferAll from "./TransferAll";
import TransferableAmount from "./TransferableAmount";
import { ThemeContext } from "@/theme/ThemeProvider";
import { InputNumber } from "antd";
import styled from 'styled-components';

const TransferAmount = ({ balance, amount, setAmount, coinType }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useContext(ThemeContext);
  const { textw, gray } = useContext(ThemeContext).theme.COLORS;
  return (
    <TransferAmountWrapper>
      <ModernInputNumber
        type={"number"}
        value={amount}
        parser={(value) =>
          value!.replace(/\$\s?|(,*)/g, "")?.replace(/[^\d.]/g, "")
        }
        rootClassName={"ovlist " + (isDarkMode ? "dark" : "light")}
        onChange={(e) => setAmount(e)}
        isDarkMode={isDarkMode}
        placeholder={`0.00 ${coinType}`}
        suffix={<TransferAll
          balance={balance}
          setAmount={setAmount}
          coinType={coinType}
        />}
      />
    </TransferAmountWrapper>
  );
};

export default TransferAmount;

const ModernInputNumber = styled(InputNumber)<{ isDarkMode: boolean }>`
  width: 100% !important;
  background: ${props => props.isDarkMode
    ? 'rgba(40, 40, 40, 0.8)'
    : 'rgba(50, 50, 50, 0.8)'
  } !important;
  border: 2px solid transparent !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  
  &:hover, &:focus, &.ant-input-number-focused {
    border-color: #FF5C17 !important;
    box-shadow: 0 0 0 3px rgba(255, 92, 23, 0.2) !important;
    transform: translateY(-1px);
  }
  
  .ant-input-number-input-wrap {
    height: 52px !important;
    background: transparent !important;
  }
  
  .ant-input-number-input {
    height: 52px !important;
    padding: 0 16px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    border: none !important;
    border-radius: 12px !important;
    background: transparent !important;
    color: ${props => props.isDarkMode ? '#FFFFFF' : '#E0E0E0'} !important;
    
    &::placeholder {
      color: ${props => props.isDarkMode ? '#7F8C8D' : '#95A5A6'} !important;
      font-weight: 400 !important;
    }
  }
  
  .ant-input-number-handler-wrap {
    display: none !important;
  }
  
  .ant-input-number-suffix {
    padding-right: 12px !important;
    background: transparent !important;
    display: flex !important;
    align-items: center !important;
    pointer-events: all !important;
    z-index: 1001 !important;
  }
  
  .ant-input-number-group-addon {
    background: transparent !important;
    border: none !important;
  }
`;

const CustomInputNumber = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`;